import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import ProductGallery from "../../components/ProductDetail/ProductGallery";
import ProductInfo from "../../components/ProductDetail/ProductInfo";
import ProductDescription from "../../components/ProductDetail/ProductDescription";
import ProductSpecs from "../../components/ProductDetail/ProductSpecs";
import ProductQA from "../../components/ProductDetail/ProductQA";
import ProductReviews from "../../components/ProductDetail/ProductReviews";
import StickySidebar from "../../components/ProductDetail/StickySidebar";
import ProductSlider from "../../components/ProductSlider/ProductSlider";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { getProduct, getActiveRelatedProducts } from "../../actions/productActions";
import { Helmet } from "react-helmet-async";

import "./Product.css";

export default function Product() {

    const dispatch = useDispatch();
    const { category: categorySlug, subCategory: subCategorySlug, product: productSlug } = useParams();
    const { product, loading, error } = useSelector((state) => state.productState);
    const { products } = useSelector((state) => state.productsState);
    const [selectedVariant, setSelectedVariant] = useState(null);
    
    // Fetch product
    useEffect(() => {
        if (productSlug) dispatch(getProduct(productSlug));
    }, [dispatch, productSlug]);

    useEffect(() => {
        dispatch(getActiveRelatedProducts(categorySlug, subCategorySlug, productSlug));
    }, [dispatch, product]);
    // When product loads, set default variant
    useEffect(() => {
        if (product?.variants?.length > 0) {
            setSelectedVariant(product.variants[0]);
        } else {
            setSelectedVariant(null);
        }
    }, [product]);

    // ERROR CASE: product not found
    if (error) {
        return (
            <div className="custom-container py-5">
                <div className="error-box">Product Not Found</div>
            </div>
        );
    }

    // LOADING CASE
    if (loading || !product) {
        return (
            <div className="custom-container py-5">
                <div className="loading-box">Loading product...</div>
            </div>
        );
    }

    // PRODUCT EXISTS BUT NOT ACTIVE
    if (!product.isActive) {
        return (
            <div className="custom-container py-5">
                <div className="error-box">This product is not available anymore.</div>
            </div>
        );
    }

    return (
        <>
            <Helmet>
                <title>{product?.seo?.metaTitle || product?.productName}</title>
                <meta name="description" content={product?.seo?.metaDescription || product?.description} />
                <meta name="keywords" content={product?.seo?.metaKeywords || product?.productName} />
                <link rel="canonical" href={product?.seo?.canonicalUrl || `https://spabrands.me/${product?.category}/${product?.subCategory}/${product?.slug}`} />
            </Helmet>

            <div className="custom-container">
                <Breadcrumbs />
                <div className="row">

                    {/* GALLERY */}
                    <div className="col-md-5">
                        <ProductGallery
                            images={
                                selectedVariant?.images?.length
                                    ? selectedVariant.images
                                    : (product.gallery || [])
                            }
                        />
                    </div>

                    {/* INFO */}
                    <div className="col-md-7">
                        <ProductInfo
                            product={product}
                            selectedVariant={selectedVariant}
                            setSelectedVariant={setSelectedVariant}
                        />
                        <ProductDescription product={product} />
                        <ProductSpecs product={product} />
                    </div>
                </div>

                {/* <ProductQA product={product} />
                    <ProductReviews /> */}

                {/* RIGHT STICKY SIDEBAR */}
                {/* <div className="col-lg-3">
                        <StickySidebar
                            selectedVariant={selectedVariant}
                            product={product}
                        />
                    </div> */}

                {/* RELATED PRODUCTS */}
                <div className="mb-5">
                    <ProductSlider title="Related Products" products={products} />
                </div>
            </div>
        </>
    );
}
